import { render, staticRenderFns } from "./AtomSpan.vue?vue&type=template&id=ef9ff7f2"
import script from "./AtomSpan.vue?vue&type=script&lang=js"
export * from "./AtomSpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports